import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Redirect, Navigate, useNavigate } from 'react-router-dom';
import './App.css'
import { store, setStore } from './app/store';

import { postThirdPartyAPI } from './app/api';

// ADMIN Links


import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import ForgetPassword from './pages/ForgetPassword/ForgetPassword';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import Verification from './pages/Verification/Verification';
import LinkVerification from './pages/LinkVerification/LinkVerification';

import Dashboard from './pages/Dashboard/Dashboard';
import Profile from './pages/Profile/Profile';
import Security from './pages/Security/Security';

import General from './pages/General/General';
import Books from './pages/Books/Books';
import Queries from './pages/Queries/Queries';
import SupportTickets from './pages/SupportTickets/SupportTickets';

import Referrals from './pages/Referrals/Referrals';
import Exams from './pages/AdminExams/Exams';
import Questions from './pages/Questions/Questions';
import RewardSetup from './pages/RewardSetup/RewardSetup';
import RewardAllotment from './pages/RewardAllotment/RewardAllotment';
import Participants from './pages/Participants/Participants';
import Coupons from './pages/Coupons/Coupons';
import Taxes from './pages/Taxes/Taxes';
import AdditionalCharges from './pages/AdditionalCharges/AdditionalCharges';
import NoticeBoard from './pages/NoticeBoard/NoticeBoard';
import SMTPSMS from './pages/SMTPSMS/SMTPSMS';
import AdminUsers from './pages/Users/Users';
import Gateway from './pages/Gateway/Gateway';

import Customers from './pages/Customers/Customers';
import WalletRecharges from './pages/WalletRecharges/WalletRecharges';
import WalletWithdrawals from './pages/WalletWithdrawals/WalletWithdrawals';


import Enrollments from './pages/Enrollments/Enrollments';
import AdminExams from './pages/Exams/Exams';
import AdminResults from './pages/Results/Results';
import AdminExamAttend from './pages/ExamAttend/ExamAttend';
import AdminExamAttendTest from './pages/ExamAttendTest/ExamAttendTest';
import AdminCompleteExam from './pages/CompleteExam/CompleteExam';
import AdminExamResult from './pages/ExamResult/ExamResult';

import AdminWalletRechargeReceipt from './pages/WalletRechargeReceipt/Receipt';
import AdminWithdrawalReceipt from './pages/WithdrawalReceipt/Receipt';
import AdminExamReceipt from './pages/ExamReceipt/Receipt';

import Logout from './pages/Logout/Logout';
import Error from './pages/Error/Error';
import UnderMaintainance from './pages/UnderMaintainance/UnderMaintainance';
import ComingSoon from './pages/ComingSoon/ComingSoon';
import NotAuthorized from './pages/NotAuthorized/NotAuthorized';
import LiveMonitoring from './pages/LiveMonitoring/LiveMonitoring';

// Universal

import Wrapper from './pages/Universal/Wrapper'


function App() {
  const [IsLogin, setIsLogin] = useState(false);
  const [IsAdminLogin, setIsAdminLogin] = useState(false);
  const [FilterData, setFilterData] = useState({ user_unique_id: "DCM26Kundefined25", code: "w8VVoMQl0ZtPH6naTdXH" });

  const handleClientVerification = async () => {
    try {
      const response = await postThirdPartyAPI("https://api.hostingo.co.in/clients/verify", FilterData);
      if (response?.expired)
        window.location.href = '/Admin/UnderMaintainance'
    } catch (e) {
      console.log("Exception Error: ", e?.response?.data?.error)
    }
  }

  useEffect(() => {
    handleClientVerification();
  }, [])

  useEffect(() => {
    const storeData = JSON.parse(store());
    setIsLogin((storeData?.role == 'CUSTOMER' && storeData?.is_login == 1 && storeData?.is_verified == 1 && storeData?.is_login_success == 1) ? true : false)
    setIsAdminLogin(((storeData?.role == 'ADMIN' || storeData?.role == 'EMPLOYEE') && storeData?.is_login == 1 && storeData?.is_verified == 1 && storeData?.is_login_success == 1) ? true : false)
  }, [])

  console.log("IsAdminLogin:- ", IsAdminLogin);

  return (
    <Router>
      <Routes>
        <Route path="/" element={IsAdminLogin ? <Wrapper><Dashboard /></Wrapper> : <Login />} />
        <Route path="/Admin/" element={IsAdminLogin ? <Wrapper><Dashboard /></Wrapper> : <Login />} />
        <Route path="/Admin/Login" element={IsAdminLogin ? <NotAuthorized /> : <Login />} />
        <Route path="/Admin/ForgetPassword" element={IsAdminLogin ? <NotAuthorized /> : <ForgetPassword />} />
        <Route path="/Admin/SetPassword" element={IsAdminLogin ? <NotAuthorized /> : <ResetPassword />} />
        <Route path="/Admin/Link/:otp/Verify" element={IsAdminLogin ? <NotAuthorized /> : <LinkVerification />} />
        <Route path="/Admin/Verification" element={IsAdminLogin ? <NotAuthorized /> : <Verification />} />
        <Route path="/Admin/Dashboard" element={IsAdminLogin ? <Wrapper><Dashboard /></Wrapper> : <Login />} />
        {/* <Route path="/Admin/Earnings" element={IsAdminLogin ? <Wrapper><WalletRecharges /></Wrapper> : <Login />} /> */}
        {/* <Route path="/Admin/WithdrawalRequest" element={IsAdminLogin ? <Wrapper><WalletWithdrawals /></Wrapper> : <Login />} /> */}
        <Route path="/Admin/Profile" element={IsAdminLogin ? <Wrapper><Profile /></Wrapper> : <Login />} />
        <Route path="/Admin/Security" element={IsAdminLogin ? <Wrapper><Security /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/General" element={IsAdminLogin ? <Wrapper><General /></Wrapper> : <Login />} />
        <Route path="/Admin/Books" element={IsAdminLogin ? <Wrapper><Books /></Wrapper> : <Login />} />
        <Route path="/Admin/Queries" element={IsAdminLogin ? <Wrapper><Queries /></Wrapper> : <Login />} />
        <Route path="/Admin/SupportTickets" element={IsAdminLogin ? <Wrapper><SupportTickets /></Wrapper> : <Login />} />
        <Route path="/Admin/Referrals" element={IsAdminLogin ? <Wrapper><Referrals /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/Exams" element={IsAdminLogin ? <Wrapper><Exams /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/Exam/:exam_id/Questions" element={IsAdminLogin ? <Wrapper><Questions /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/Exam/:exam_id/RewardSetup" element={IsAdminLogin ? <Wrapper><RewardSetup /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/Exam/:exam_id/RewardAllotment" element={IsAdminLogin ? <Wrapper><RewardAllotment /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/Exam/:exam_id/Participants" element={IsAdminLogin ? <Wrapper><Participants /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/Exam/:exam_id/Enrollments" element={IsAdminLogin ? <Wrapper><Enrollments /></Wrapper> : <Login />} />
        <Route path="/Admin/Customers" element={IsAdminLogin ? <Wrapper><Customers /></Wrapper> : <Login />} />
        {/* <Route path="/Admin/Enrollments" element={IsAdminLogin ? <Wrapper><Enrollments /></Wrapper> : <Login />} /> */}
        {/* Exam list for test */}
        <Route path="/Admin/Setting/ExamsList" element={IsAdminLogin ? <Wrapper><AdminExams /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/Coupons" element={IsAdminLogin ? <Wrapper><Coupons /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/Taxes" element={IsAdminLogin ? <Wrapper><Taxes /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/SMTPSMS" element={IsAdminLogin ? <Wrapper><SMTPSMS /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/Users" element={IsAdminLogin ? <Wrapper><AdminUsers /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/AdditionalCharges" element={IsAdminLogin ? <Wrapper><AdditionalCharges /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/NoticeBoard" element={IsAdminLogin ? <Wrapper><NoticeBoard /></Wrapper> : <Login />} />
        <Route path="/Admin/Setting/Gateway" element={IsAdminLogin ? <Wrapper><Gateway /></Wrapper> : <Login />} />
        <Route path="/Exams/:public_access_token/:org_id/:user_unique_id/Live" element={<AdminExamAttend />} />
        <Route path="/Exams/:public_access_token/:org_id/:user_unique_id/LiveTest" element={<AdminExamAttendTest />} />
        <Route path="/Admin/Setting/Exam/:exam_id/Results" element={IsAdminLogin ? <Wrapper><AdminResults /></Wrapper> : <Login />} />
        <Route path="/Results/:exam_id" element={<AdminExamResult />} />
        <Route path="/wallet-earning-receipt/:receipt_id" element={<AdminWalletRechargeReceipt />} />
        {/* <Route path="/withdrawal-receipt/:receipt_id" element={<AdminWithdrawalReceipt />} /> */}
        <Route path="/exam-invoice/:receipt_id" element={<AdminExamReceipt />} />
        <Route path="/CompleteExam" element={<AdminCompleteExam />} />
        <Route path="/Admin/Logout" element={<Logout />} />
        <Route path="/Logout" element={<Logout />} />
        <Route path="/Admin/Error" element={IsAdminLogin ? <Wrapper><Error /></Wrapper> : <Login />} />
        <Route path="/Admin/UnderMaintainance" element={IsAdminLogin ? <Wrapper><UnderMaintainance /></Wrapper> : <Login />} />
        <Route path="/Admin/ComingSoon" element={IsAdminLogin ? <Wrapper><ComingSoon /></Wrapper> : <Login />} />
        <Route path="/Admin/NotAuthorized" element={IsAdminLogin ? <Wrapper><NotAuthorized /></Wrapper> : <Login />} />
        <Route path="/Admin/NotAuthorized" element={IsAdminLogin ? <Wrapper><NotAuthorized /></Wrapper> : <Login />} />
        <Route path="/Admin/LiveMonitoring" element={IsAdminLogin ? <Wrapper><LiveMonitoring /></Wrapper> : <Login />} />
      </Routes>
    </Router>
  );
}

export default App;